// extracted by mini-css-extract-plugin
export default {"Text":"Description-module__Text--aisR2","Box":"Description-module__Box--OHUTv"};